const scrollspy = (function () {
	/** Private **/
	let spyUIWrapper         = document.querySelector('.spyUiWrapper');
	let previousScrollPosition = 0;
	let navigationHeight, scrollSpyElements;
	let currentIndex = 0;

	function spy_the_scrolling(event) {
		const currentPosition = window.scrollY ? window.scrollY : window.pageYOffset;
		// Scroll down
		if(currentPosition > previousScrollPosition){
			scrollSpyElements.forEach(currentElement => {
				if(currentPosition >= currentElement.inpoint && !currentElement.shown && currentIndex < scrollSpyElements.length -1) {
					currentIndex++;
					currentElement.shown = true;
					showCurrentElement();
				}
			})
		}

		// Scroll up
		else if(currentPosition < previousScrollPosition) {
			scrollSpyElements.forEach(currentElement => {
				if(currentElement.outpoint >= currentPosition && currentElement.shown && currentIndex > 0) {
					currentIndex--;
					currentElement.shown = false;
					showCurrentElement();
				}
			})
		}

		previousScrollPosition = currentPosition;
	};

	function handleResize(){
		navigationHeight = document.querySelector('nav.main-nav').offsetHeight;
		scrollSpyElements.forEach(currentElement => currentElement.setInAndOutpoint(navigationHeight));
	}

	function showCurrentElement(){
		spyUIWrapper.innerText = scrollSpyElements[currentIndex].title;
	}

	/** Public **/
	function setup() {
		// ScrollSpyElement.offsetTop - navigationHeight + ScrollSpyElement.section_title.offsetHeight === 596 beim ersten
		//1. Build scrollspacy instances
		navigationHeight = document.querySelector('nav.main-nav').offsetHeight;
		scrollSpyElements = Array.from(document.querySelectorAll('.scrollspy')).map(current => new scrollSpyElement(current,navigationHeight));

		//2. Select scrollspy UI (Where the current scrollSpy-elements title gets shown)
		spyUIWrapper = document.querySelector('.scrollSpyUI');

		//3. Add scroll Event-Listener to scrollspy - instances
		window.addEventListener('scroll', spy_the_scrolling);

		//4. Add resize eventlistener
		window.addEventListener('resize',handleResize);

		//5. Initialize scrollspyUI with firstElement
		scrollSpyElements[0].shown = true;
		showCurrentElement();

		//6. Create Spacer
		const footer = document.querySelector('footer.the_footer');
		const spacer = document.createElement('div');
		spacer.id = 'spacer';

		if(footer)
			document.body.insertBefore(spacer,footer);

		else
			document.body.appendChild(spacer);
	}

	return setup
})();